import { GoogleActUTMParams, createUtmURL } from '../../utils/createUtmURL';
import BookingSection from '../BookingSection';
import React, { Component } from 'react';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc/components/src/grid';

const BaseBookingColumnContainer = styled.div`
    height: 100%;
    position: relative; // create new stacking context
    z-index: 1;
    overflow: auto;

    ${breakpoint.medium} {
        overflow: visible;
    }
`;

const BookingColumnContainer1Z = styled(BaseBookingColumnContainer)`
    ${breakpoint.medium} {
        padding-top: ${p => p.marginTop}px;
    }
`;

export default class BookingColumn extends Component {
    render() {
        const {
            carrierId,
            currentLocationCloudId,
            host,
            initParameters,
            is1Z,
            onClick,
            planId,
            procedureId,
            provider,
            providerId,
            showNewExistingToggle,
        } = this.props;

        // booking gets confused if it tries to book with procedure undefined and can create weird issues for patients
        // where the profile page shows a time, but then in booking flow it is no longer available
        // (because profile page was using undefined procedure id and booking flow was using the default...)
        const selectedProcedureId = Boolean(procedureId)
            ? procedureId
            : provider.defaultProcedureId;

        const BookingColumnContainer = is1Z ? BookingColumnContainer1Z : BaseBookingColumnContainer;

        return (
            <BookingColumnContainer
                data-test="profile-booking-column"
                marginTop={showNewExistingToggle ? 35 : 40}
                onClick={onClick}
            >
                <span
                    itemProp="potentialAction"
                    itemScope
                    itemType="http://schema.org/ReserveAction"
                >
                    <span
                        itemProp="target"
                        itemScope
                        itemType="http://schema.org/EntryPoint"
                    >
                        <meta
                            content="http://schema.org/DesktopWebPlatform"
                            itemProp="actionPlatform"
                        />
                        <meta
                            content="http://schema.org/IOSPlatform"
                            itemProp="actionPlatform"
                        />
                        <meta
                            content="http://schema.org/AndroidPlatform"
                            itemProp="actionPlatform"
                        />
                        <meta
                            content="en-Us"
                            itemProp="inLanguage"
                        />
                        <meta
                            content={createUtmURL(`https://${host}${provider.profileUrl}`, GoogleActUTMParams)}
                            itemProp="url"
                        />
                    </span>
                    <span
                        itemProp="result"
                        itemScope
                        itemType="http://schema.org/Reservation"
                    >
                        <meta
                            content="Appointment"
                            itemProp="name"
                        />
                    </span>
                </span>
                <BookingSection
                    carrierId={carrierId}
                    currentLocationCloudId={currentLocationCloudId}
                    data-test="booking-column-booking-section"
                    isNewPatient={initParameters.isNewPatient}
                    planId={planId}
                    procedureId={selectedProcedureId}
                    provider={provider}
                    providerId={providerId}
                    showNewExistingToggle={showNewExistingToggle}
                />
            </BookingColumnContainer>
        );
    }
}
